import { colors } from '../../../../theme';

const roleManagerStyle = (theme) => ({
  roleManagerTable: {
    '&.MuiTableHead-root': {
      borderBottom: `0.15vw solid ${colors.actionIconsColor}`,
    },
    '& .MuiTableCell-head': {
      fontSize: '0.9vw',
      '@media (min-width: 1200px)': {
        padding: '1.5vw 0.5vw',
      },
      color: colors.actionIconsColor,
      fontWeight: 600,
      [theme.breakpoints.down('lg')]: {
        fontSize: 'calc(12px + 6 * ((100vw - 320px) / 1199))',
      },
    },
    '& .MuiTableCell-body': {
      fontSize: '0.9vw',
      '@media (min-width: 1200px)': {
        padding: '1.5vw 0.5vw',
      },
      [theme.breakpoints.down('lg')]: {
        fontSize: 'calc(12px + 6 * ((100vw - 320px) / 1199))',
      },
      '& .MuiSvgIcon-root': {
        '@media (min-width: 1200px)': {
          width: '1.5vw',
          height: '1.5vw',
        },
      },
    },
  },
  cursorPointer: { cursor: 'pointer' },
  oneLineRowName: {
    whiteSpace: 'nowrap',
  },
});

export default roleManagerStyle;
